import { render, staticRenderFns } from "./SkalaA1.vue?vue&type=template&id=f201df84&scoped=true&"
import script from "./SkalaA1.vue?vue&type=script&lang=js&"
export * from "./SkalaA1.vue?vue&type=script&lang=js&"
import style0 from "./SkalaA1.vue?vue&type=style&index=0&id=f201df84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f201df84",
  null
  
)

export default component.exports